import { gql } from "@apollo/client";
import { COLOR_BLACK } from "helpers/colors";
import useData from "helpers/useData";
import useFullscreenState from "helpers/useFullscreenState";
import Dialog from "molecules/Dialog";
import React from "react";

import HighlightPlayer, { HighlightPlayerFragment } from "./HighlightPlayer";

export default function HighlightPlayerDialog({ open, onClose, eventId }) {
  const [data] = useData(
    gql`
      query HighlightPlayerDialog($eventId: ID!) {
        event(id: $eventId) {
          id
          ...HighlightPlayerFragment
        }
      }
      ${HighlightPlayerFragment}
    `,
    { eventId },
    { skip: !open },
  );
  const [fullscreen] = useFullscreenState();

  return (
    <Dialog
      noPadding
      open={open}
      onClose={onClose}
      inverse
      {...(fullscreen
        ? { fullHeight: true, fullWidth: true }
        : {
            mediumWidth: true,
          })}
      PaperProps={{
        style: {
          backgroundColor: COLOR_BLACK,
        },
      }}
    >
      <HighlightPlayer event={data?.event} eventId={eventId} />
    </Dialog>
  );
}
